// extracted by mini-css-extract-plugin
var _1 = "uJycCrdPM2fud4x0CZdb";
var _2 = "QBSInBC46wDJHSSXCko_";
var _3 = "t98vn79HNSGirbgd2gOW";
var _4 = "YOATuRjSzwN5VM4y7bQQ";
var _5 = "hOwqefIR8LI80N1n1OrQ";
var _6 = "pgaoVr25S_TiTHX13eOW";
export { _1 as "container", _2 as "h1", _3 as "innerContainer", _4 as "letterBoard", _5 as "light", _6 as "withSpacing" }
